<template>
  <div>
    <div v-if="isListEmpty(employerDataObj).length">
    <div v-for="(empItem, eIndex) in employerDataObj" :key="eIndex" class="py-1 mx-1">
      <div header-tag="header" class="p-1" role="tab">
        <b-button
        :id="`${eIndex}EMP${borrowerId}`"
          v-b-toggle="`accordion-dist${eIndex}${borrowerId}`"
          block
          class="d-flex collapseSubHeader"
          :class="$style.nooutline"
          @click="isVisibleEmp = !isVisibleEmp"
        >
          <p class="mb-0 text-dark font-weight-bold"
            >{{ empItem.employerName }}</p
          >
          <strong class="ml-auto"
            ><i
              :class="`fa fa-angle-${isVisibleEmp ? 'up' : 'down'
                } text-dark`
                "
            ></i
          ></strong>
        </b-button>
      </div>
    <b-collapse :id="`accordion-dist${eIndex}${borrowerId}`" visible>
    <div v-if="!empDisabledStatus.includes(empItem.employmentStatus)">
    <div v-if="isListEmpty(empItem.employerDetails).length" class="mx-1 mt-1">
      <div
        v-for="(item, index) in empItem.employerDetails"
        :key="index"
        :class="$style.relativesContainer"
        class="border py-1"
      >
        <div class="row">
          <div class="col" :class="$style.status"
            ><strong>Company Name: </strong>{{ formatDisplay(item.companyName) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Phone Number: </strong><span v-if="item.phoneNumber">{{ formatDisplay(item.phoneNumber) }}
            <span v-if="item.phoneLisitingVerified === 'Y'">(Verified)</span>
            <span v-else>(Not Verified)</span></span>
          </div>
          <div class="col" :class="$style.status"
            ><strong>Date First Seen: </strong>{{ formatDisplay(item.dateFirstSeen) }}</div
          >
        </div>

        <div class="row" :class="$style.border1">
          <div class="col-4" :class="$style.status"
            ><strong>Address: </strong>{{ formatDisplay(item.address) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>FEIN: </strong>{{ formatDisplay(item.fein) }}</div
          >
          <div class="col" :class="$style.status"
            ><strong>Date Last Seen: </strong>{{ formatDisplay(item.dateLastSeen) }}</div
          >
        </div>
      </div>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
    </div>
    <div v-else class="text-center py-1 mx-1 border baseContentFont">
      *** Employment Status: {{ empItem.employmentStatus }} ***
    </div>
    </b-collapse>
   </div>
    </div>
   <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    employerData: {
      type: Object,
      default: () => {},
    },
    borrowerId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isVisibleEmp: false,
      empDisabledStatus: [
        'Other Income',
        'Unemployed',
      ],
    }
  },
  computed: {
    employerDataObj() {
      return this.employerData.employmentData || []
    },
    employmentStatus() {
      return this.employerData.employmentStatus || null
    },
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
  },
}
</script>
<style lang="scss" module>
@import '@design';

.relativesContainer {
  padding: 0 15px;
  // border: 1px solid #6d6e70;
}

.relativesContainer:nth-child(odd) {
  background: #fff;
}

.relativesContainer:nth-child(even) {
  background: #eee;
}

.status {
  font-size: $size-content-font;
  color: $color-text-gray;
}
</style>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
.collapseSubHeader {
  background-color: $color-raisin-40 !important;
  border: none;
}
</style>
